import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Checkbox,
	FormControlLabel
} from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import moment from "moment";
import { FormControl } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import Tooltip from "@mui/material/Tooltip";
import ThumbUpAltRoundedIcon from "@mui/icons-material/ThumbUpAltRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import SearchIcon from "@mui/icons-material/Search";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import { getMerchantChargeList } from "../../redux/actions/getMerchantChargeListAction";
import { merchantHistory } from "../../redux/actions/merchantHistoryAction";
import { modifyMerchant } from "../../redux/actions/modifyMerchantAction";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import ReactToExcel from "react-html-table-to-excel";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import {
	logoutUser,
	resetApp,
	resetLogout
} from "../../redux/actions/authActions";
import {
	getKycApproveRejects,
	resetGetKycApproveReject
} from "../../redux/actions/getKycApproveRejectAction";
import authTokenReducer from "../../redux/reducers/authTokenReducer";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Autocomplete from "@mui/lab/Autocomplete";
import {
	resetGetCustomerIdAndNameList,
	getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function ChargeMaster() {
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);

	const [selectedToDate, setSelectedToDate] = useState(new Date());

	const navigate = useHistory();
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [isLoading, setIsLoading] = useState(true);
	const [editOpen, setEditOpen] = React.useState(false);
	const [viewOpen, setViewOpen] = React.useState(false);
	const [merchantHistoryMod, setMerchantHistoryMod] = useState(false);
	const [modify, setModify] = useState(false);
	const [type, setType] = useState();
	const [getMerchantChargeListStatus, setGetMerchantChargeListStatus] =
		useState(false);
	const [getMerchantChargeListArray, setGetMerchantChargeListArray] =
		useState("");

	const [getMerchantHistoryStatus, setGetMerchantHistoryStatus] =
		useState(false);
	const [getMerchantHistoryArray, setGetMerchantHistoryArray] = useState("");

	const [modifyMerchantStatus, setModifyMerchantStatus] = useState(false);
	const [modifyMerchantArray, setModifyMerchantArray] = useState("");
	const [merchantId, setMerchantId] = useState("");

	const handleChange = ({ target: { name, value } }) => {


		if (name === "merchantId") {
			// console.log("memberId", memberId)
			setMerchantId(value)
		}
	}

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);


	var authToken = regenerateTokenRes.data.AuthToken;
	const classes = useStyles();
	const dispatch = useDispatch();

	const [mappindIdMod, setMappingIdMod] = useState("");

	const [modifyMerchantInp, setModifyMerchantInp] = useState({
		merchantIdMod: "",
		partnerIdMod: "",
		chargeNameMod: "",
		currencyMod: "",
		DynamicInputMod: "",
		merchantRateMod: "",
		agentComissionMod: "",
		partnerCommissionMod: "",
		sequenceNumMod: ""
	});

	const {
		merchantIdMod,
		partnerIdMod,
		chargeNameMod,
		currencyMod,
		DynamicInputMod,
		merchantRateMod,
		agentComissionMod,
		partnerCommissionMod,
		sequenceNumMod
	} = modifyMerchantInp;

	const onInputChangeMod = ({ target: { name, value } }, type) => {
		// setUser({ ...user, [e.target.name]: e.target.value });
		const obj = {
			...modifyMerchantInp
		};

		if (type == "number") {
			obj[name] = Util.verifyMobile(value) ? value : obj[name];
		} else if (type == "alphabet") {
			obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
		} else if (type == "both") {
			obj[name] = Util.alphaNumeric(value) ? value : obj[name];
		} else {
			// obj[name] = value.trim()
			obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
		}
		setModifyMerchantInp(obj);
	};

	// const [user, setUser] = useState({
	// 	merchantId: ""
	// });

	// const { merchantId } = user;

	// const onInputChange = ({ target: { name, value } }, type) => {
	// 	// setUser({ ...user, [e.target.name]: e.target.value });
	// 	// const obj = {
	// 	// 	...user
	// 	// };

	// 	if (type == "number") {
	// 		obj[name] = Util.verifyMobile(value) ? value : obj[name];
	// 	} else if (type == "alphabet") {
	// 		obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
	// 	} else if (type == "both") {
	// 		obj[name] = Util.alphaNumeric(value) ? value : obj[name];
	// 	} else {
	// 		// obj[name] = value.trim()
	// 		obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
	// 	}
	// 	// setUser(obj);
	// };

	const handleDateChange = (date) => {
		setSelectedDate(date);

	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	const getMerchantChargeListRes = useSelector(
		({ getMerchantChargeList }) => getMerchantChargeList
	);

	const getMerchantHistoryRes = useSelector(
		({ merchantHistory }) => merchantHistory
	);

	const modifyMerchantRes = useSelector(({ modifyMerchant }) => modifyMerchant);

	const getRoleListRes = useSelector(({ getRoleList }) => getRoleList);

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getMerchantChargeListReq();
		}
	}, [regenerateTokenRes.data.status]);

	const getMerchantChargeListReq = () => {
		setGetMerchantChargeListStatus(true);
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				memberId: merchantId.split("-")[0] || ""
			}
		};
		dispatch(getMerchantChargeList(req, authToken));
		setPage(0)
	};

	const getMerchantChargeListFunc = () => {
		if (getMerchantChargeListStatus) {
			if (getMerchantChargeListRes.data.status == "success") {
				setGetMerchantChargeListArray(getMerchantChargeListRes.data.manualList);
				setIsLoading(false);
			}
			if (getMerchantChargeListRes.data.status == "failed") {
				setGetMerchantChargeListArray(getMerchantChargeListRes.data);
				setIsLoading(false);
				if (
					getMerchantChargeListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getMerchantChargeListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getMerchantChargeListFunc();
	}, [getMerchantChargeListRes.data.status]);

	const merchantHistoryReq = (mappingId, type) => {
		setGetMerchantHistoryStatus(true);
		setType(type);
		const req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				action: type,
				mappindId: mappingId
			}
		};
		dispatch(merchantHistory(req, authToken));
		if (type == "modify") {
			setModify(true);
		}
		if (type == "history") {
			setMerchantHistoryMod(true);
		}
		setMappingIdMod(mappingId);
	};

	const getMerchantHistoryFunc = () => {
		if (getMerchantHistoryStatus) {
			if (getMerchantHistoryRes.data.status == "success") {
				setGetMerchantHistoryArray(getMerchantHistoryRes.data.manualList);
			}
			if (getMerchantHistoryRes.data.status == "failed") {
				setGetMerchantHistoryArray(getMerchantHistoryRes.data);
				if (
					getMerchantHistoryRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getMerchantHistoryRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		getMerchantHistoryFunc();
	}, [getMerchantHistoryRes.data.status]);

	useEffect(() => {
		if (getMerchantHistoryRes.data.status == "success") {
			if (type == "modify") {
				setModifyMerchantInp({
					merchantIdMod: getMerchantHistoryArray.memberId,
					partnerIdMod: getMerchantHistoryArray.partnerId,
					chargeNameMod: getMerchantHistoryArray.chargeName,
					currencyMod: getMerchantHistoryArray.currency,
					DynamicInputMod: getMerchantHistoryArray.inputRequired,
					merchantRateMod: getMerchantHistoryArray.chargeValue,
					agentComissionMod: getMerchantHistoryArray.agentChargeValue,
					partnerCommissionMod: getMerchantHistoryArray.partnerChargeValue,
					sequenceNumMod: getMerchantHistoryArray.sequenceNum
				});
				if (
					getMerchantHistoryArray.effectiveStartDate &&
					getMerchantHistoryArray.effectiveEndDate
				) {
					setSelectedDate(
						getMerchantHistoryArray.effectiveStartDate.split(" ")[0]
					);
					setSelectedToDate(
						getMerchantHistoryArray.effectiveEndDate.split(" ")[0]
					);
				}
			}
		}
	}, [getMerchantHistoryArray]);

	const modifyMerchantReq = () => {
		setModifyMerchantStatus(true);
		let req = {
			actionCustomerMasterRequestVO: {
				walletOwnerId: regenerateTokenRes.data.partnerId || "",
				memberCharge: merchantRateMod,
				agentCharge: agentComissionMod,
				partnerCharge: partnerCommissionMod,
				fdtstamp: moment(selectedDate).format("YYYY-MM-DD"),
				tdtstamp: moment(selectedToDate).format("YYYY-MM-DD"),
				isInputRequired: DynamicInputMod,
				mappindId: mappindIdMod
			}
		};
		dispatch(modifyMerchant(req, authToken));
	};

	const modifyMerchantFunc = () => {
		if (modifyMerchantStatus) {
			if (modifyMerchantRes.data.status == "success") {
				setModifyMerchantArray(modifyMerchantRes.data);
				setNotificationOpen(true);
				getMerchantChargeListReq();
				setModify(false);
			}
			if (modifyMerchantRes.data.status == "failed") {
				setModifyMerchantArray(modifyMerchantRes.data);
				setNotificationOpen(true);
				setModify(false);
				if (
					modifyMerchantRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					modifyMerchantRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		modifyMerchantFunc();
	}, [modifyMerchantRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setEditOpen(false);
		setViewOpen(false);
		setMerchantHistoryMod(false);
		setModify(false);
		setModifyMerchantInp({
			mappindIdMod: "",
			merchantIdMod: "",
			partnerIdMod: "",
			chargeNameMod: "",
			currencyMod: "",
			DynamicInputMod: "",
			merchantRateMod: "",
			agentComissionMod: "",
			partnerCommissionMod: "",
			sequenceNumMod: ""
		});
		setMappingIdMod("");
		setSelectedDate("");
		setSelectedToDate("");
	};

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};
	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);

	const filterOptions = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}
	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "10px",
							textAlign: "center"
						}}
					>
						{/* <Grid item xs={12} md={8} sm={3} lg={3}></Grid> */}

						<Grid item xs={12} md={4} sm={3} lg={3}>
							<NavLink to="/index/addMerchantCharge">
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									Add New Merchant Charges
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item xs={12} md={4} sm={3} lg={3}>
							<NavLink to="/index/gatewayAccountCharge">
								<CustomButton
									style={{
										padding: "8px"
									}}
								>
									Gateway Account Charges
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item xs={12} md={4} sm={3} lg={2}>
							<NavLink to="/index/addEditChargeMaster">
								<CustomButton
									style={{
										padding: "8px"
									}}
								// onClick={() => setData(row, "view")}
								>
									Charge Master
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						{/* <Grid item xs={12} sm={6} md={4} lg={3}>
							<TextField
								size="small"
								color="primary"
								type="text"
								label="Merchant Id"
								fullWidth={true}
								name="merchantId"
								value={merchantId}
								variant="standard"
								// onChange={onInputChange}
								onChange={(e) => onInputChange(e, "number")}
							></TextField>
						</Grid> */}

						<Grid item xs={12} sm={12} md={4} lg={4}>
							<Autocomplete
								id="combo-box-demo"
								options={[].concat(
									getCustomerIdAndNameListRes.data.currencyList || [""]
								)}
								getOptionLabel={(option) => option}
								filterOptions={filterOptions}
								value={merchantId}
								onChange={handleChange}
								onInputChange={(event, newInputValue) => {
									setMerchantId(newInputValue);
								}}
								renderInput={(params) => (
									<TextField
										autoFocus
										margin="dense"
										id="name"
										label="Merchant ID"
										style={{ marginTop: "3px" }}
										// required
										type="tel"
										fullWidth
										{...params}
										// value={merchantID}
										name="merchantId"
										// onChange={(e) => onInputChange(e, "number")}

										variant="standard"
										sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
									/>
								)}
							/>
						</Grid>
						<Grid item xs={12} sm={6} md={4} lg={3}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getMerchantChargeListReq}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getMerchantChargeListArray.length == 0 ||
					!getMerchantChargeListStatus || getMerchantChargeListRes.data.status === "failed" ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Summary Data
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									style={{ color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<div>
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography
										variant="body1"
										style={{ fontWeight: "700" }}
										className="themeText"
									>
										Report Table
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="text-nowrap my-3">
									<Table className={classes.table}>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Mapping ID{" "}
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Partner ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Merchant ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Currency
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Charge Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Merchant Rate
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Agent Commission
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Partner Commission
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Seq No
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
											</TableRow>
										</TableHead>

										<TableBody>
											{getMerchantChargeListArray &&
												[]
													.concat(getMerchantChargeListArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.mappingId}
															</TableCell>
															<TableCell align="center">
																{row.partnerId}
															</TableCell>
															<TableCell align="center">
																{row.memberId}
															</TableCell>
															<TableCell align="center">
																{row.currency}
															</TableCell>

															<TableCell align="center">
																{row.chargeName}
															</TableCell>
															<TableCell align="center">
																{row.chargeValue}
															</TableCell>

															<TableCell align="center">
																{row.agentComission}
															</TableCell>

															<TableCell align="center">
																{row.partneComission}
															</TableCell>

															<TableCell align="center">
																{row.sequenceNum}
															</TableCell>

															<TableCell align="center">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		merchantHistoryReq(row.mappingId, "modify")
																	}
																>
																	Modify
																</CustomButton>
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		merchantHistoryReq(row.mappingId, "history")
																	}
																>
																	History
																</CustomButton>
															</TableCell>
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={[].concat(getMerchantChargeListArray).length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					</div>
				)}
			</Layout>

			<div>
				<Dialog
					open={merchantHistoryMod}
					onClose={handleClose}
					fullWidth={true}
					maxWidth={"unset"}
				>
					<DialogTitle>History</DialogTitle>
					<DialogContent>
						<TableContainer component={Paper} className="text-nowrap my-3">
							<Table className={classes.table}>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Mapping ID{" "}
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Merchant ID
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Partner ID
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Currency
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Partner Charge
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Agent Charge
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Member Charge
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Start Date
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											End Date
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getMerchantHistoryArray &&
										[]
											.concat(getMerchantHistoryArray)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((row, index) => (
												<TableRow>
													<TableCell align="center">{row.mappingId}</TableCell>
													<TableCell align="center">{row.memberId}</TableCell>
													<TableCell align="center">{row.partnerId}</TableCell>
													<TableCell align="center">{row.currency}</TableCell>

													<TableCell align="center">
														{row.partneComission}
													</TableCell>
													<TableCell align="center">
														{row.agentComission}
													</TableCell>

													<TableCell align="center">
														{row.merchantValue}
													</TableCell>

													<TableCell align="center">
														{row.effectiveStartDate}
													</TableCell>

													<TableCell align="center">
														{row.effectiveEndDate}
													</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
						</TableContainer>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						{/* <Button
                            style={{
                                backgroundColor: "#fff",
                                color: "#000"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Close
                        </Button> */}

						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Close
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			<div>
				<Dialog open={modify} onClose={handleClose}>
					<DialogTitle>Modify Merchant Charge</DialogTitle>
					<DialogContent>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Member Id"
							fullWidth={true}
							name="merchantIdMod"
							variant="standard"
							value={merchantIdMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Partner Id"
							variant="standard"

							fullWidth={true}
							name="partnerIdMod"
							value={partnerIdMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Charge Name"
							fullWidth={true}
							name="chargeNameMod"
							variant="standard"

							value={chargeNameMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							variant="standard"

							label="Currency"
							fullWidth={true}
							name="currencyMod"
							value={currencyMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							required
							select
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							variant="standard"

							label="Dynamic Input"
							fullWidth={true}
							name="DynamicInputMod"
							value={DynamicInputMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						>
							<MenuItem value="Y">Y</MenuItem>
							<MenuItem value="N">N</MenuItem>
						</TextField>
						{/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="date"
                            label="Start Date"
                            fullWidth={true}
                            name="startDateMod"
                            value={startDateMod || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        ></TextField> */}
						<InputLabel style={{ margin: "10px 0px 0px 0px" }}>
							Start Date
						</InputLabel>
						<FormControl fullWidth>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<DatePicker
									// label="Start Date"
									format="MM/dd/yyyy"
									value={selectedDate}
									onChange={handleDateChange}
								/>
							</LocalizationProvider>
						</FormControl>
						{/* <TextField
                            required
                            style={{ marginTop: "10px" }}
                            size="small"
                            color="primary"
                            type="date"
                            label="End Date"
                            fullWidth={true}
                            name="endDateMod"
                            value={endDateMod || ""}
                            onChange={(e) => onInputChangeMod(e)}
                        ></TextField> */}
						<InputLabel style={{ margin: "10px 0px 0px 0px" }}>
							End Date
						</InputLabel>
						<FormControl fullWidth>
							<LocalizationProvider dateAdapter={AdapterDateFns}>
								<DatePicker
									// label="End Date"
									format="MM/dd/yyyy"
									value={selectedToDate}
									onChange={handleToDateChange}
									minDate={selectedDate}
								/>
							</LocalizationProvider>
						</FormControl>
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Merchant Rate"
							fullWidth={true}
							variant="standard"

							name="merchantRateMod"
							value={merchantRateMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							label="Agent Commission"
							fullWidth={true}
							variant="standard"

							name="agentComissionMod"
							value={agentComissionMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							variant="standard"

							label="Partner Commission"
							fullWidth={true}
							name="partnerCommissionMod"
							value={partnerCommissionMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
						<TextField
							disabled
							required
							style={{ marginTop: "10px" }}
							size="small"
							color="primary"
							type="text"
							variant="standard"

							label="Sequence Number"
							fullWidth={true}
							name="sequenceNumMod"
							value={sequenceNumMod || ""}
							onChange={(e) => onInputChangeMod(e)}
						></TextField>
					</DialogContent>
					<DialogActions style={{ padding: "14px" }}>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={handleClose}
						>
							Cancel
						</CustomButton>
						<CustomButton
							style={{
								padding: "8px"
							}}
							onClick={modifyMerchantReq}
						>
							Update
						</CustomButton>
					</DialogActions>
				</Dialog>
			</div>

			{modifyMerchantArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{modifyMerchantArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{modifyMerchantArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}

						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{modifyMerchantArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
}

export default ChargeMaster;
